import type { Dispatch, SetStateAction } from 'react'
import React, { useContext as useContextCore } from 'react'
import type { SetState } from '@ztechapps/common.hook'
import { useHistory, useObjectState } from '@ztechapps/common.hook'
import type { MenuPopUpEnum } from './MenuPopUpEnum'

export type ProviderProps = {
  children: React.ReactNode
}
export type MenuTarget = {
  show: MenuPopUpEnum
  target: EventTarget
}
export type ContextType = {
  open: boolean
  setOpen: Dispatch<SetStateAction<boolean>>
  menuTarget: MenuTarget
  setMenuTarget: SetState<MenuTarget>
  onSuccessSubmit: (route: string) => void
  onCloseMenu: () => void
} & Omit<ProviderProps, 'children'>

const context = React.createContext<ContextType>({} as ContextType)
const CoreProvider = context.Provider

export const Provider = ({ children, ...props }) => {
  const [open, setOpen] = React.useState(false)
  const [menuTarget, setMenuTarget] = useObjectState<MenuTarget>({ show: null, target: null })
  const history = useHistory()

  const onSuccessSubmit = (route: string) => {
    onCloseMenu()
    history.push(route)
  }

  const onCloseMenu = () => {
    setMenuTarget({ show: null, target: null })
    setOpen(false)
  }

  return (
    <CoreProvider value={{ ...props, open, setOpen, menuTarget, setMenuTarget, onSuccessSubmit, onCloseMenu }}>
      {children}
    </CoreProvider>
  )
}

export const useContext = () => useContextCore(context)
